module.exports = __webpack_public_path__ + "static/media/search.1102a2d5.svg";